import { render } from "./FirstReservePopUp.vue?vue&type=template&id=587f0f5b"
import script from "./FirstReservePopUp.vue?vue&type=script&lang=js"
export * from "./FirstReservePopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__